<template>
    <div class="entity-modal">
       <b-form >
             <input id="entity-id" type="hidden" v-model="entity.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group label="Nome:" label-for="entity-name_entity">
                        <b-form-input id="entity-name_entity" type="text"
                            v-model="entity.name_entity" 
                            required
                            size="sm"
                            placeholder="Nome do Cliente/Fornecedor..." 
                        />
                    </b-form-group>
                </b-col>   
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="entity.physical_person" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="entity-physical_person"
                            >
                            <label class="form-check-label" for="entity-physical_person">
                                Pessoa Física?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">    
                        <b-form-input v-if="entity.physical_person" 
                            v-mask="['###.###.###-##']" 
                            id="entity-cnpj_cpf" 
                            type="text"
                            v-model="entity.cnpj_cpf" 
                            required
                            size="sm"
                            placeholder="CPF..." 
                        />
                        <b-form-input 
                            v-else v-mask="['##.###.###/####-##']" 
                            id="entity-cnpj_cpf" type="text"
                            v-model="entity.cnpj_cpf" 
                            required
                            size="sm"
                            placeholder="CNPJ..." 
                        />    
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="entity.blocked" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="entity-blocked"
                            >
                            <label class="form-check-label" for="entity-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
            <b-card no-body>
                    <b-tabs card vertical >
                        <b-tab title="Registro" active>
                        <b-form>
                             <b-row>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Inscrição Estadual:" label-for="entity-insc_state">
                                        <b-form-input 
                                            id="entity-insc_state" 
                                            type="text"
                                            v-model="entity.insc_state" 
                                            size="sm"
                                            placeholder="Incrição Estadual" 
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group label="Inscrição Municipal:" label-for="entity-insc_municipal">
                                        <b-form-input 
                                            id="entity-insc_municipal" 
                                            type="text"
                                            v-model="entity.insc_municipal" 
                                            size="sm"
                                            placeholder="Incrição Municipal" 
                                        />
                                    </b-form-group>
                                </b-col>
                                 <b-col md="3" sm="12">
                                    <b-form-group label="Junta Comercial:" label-for="entity-insc_joint">
                                        <b-form-input 
                                            id="entity-insc_joint" 
                                            type="text"
                                            v-model="entity.insc_joint" 
                                            size="sm"
                                            placeholder="Incrição na Junta Comercial" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4" sm="12">
                                <b-form-group label="Nome Fantasia:" label-for="entity-fantasy_name">
                                    <b-form-input 
                                        id="entity-fantasy_name" 
                                        type="text"
                                        v-model="entity.fantasy_name" 
                                        size="sm"
                                        placeholder="Nome Fantasia" 
                                    />
                                </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form>

                    </b-tab >
                    <b-tab title="Endereço" >
                        <b-form>
                            <b-row>
                                <b-col md="2" sm="12">
                                    <b-form-group 
                                        label="CEP:" 
                                        label-for="entity-zip_code">
                                    <b-form-input 
                                        v-mask="['#####-###']" 
                                        id="entity-zip_code" type="text"
                                        v-model="entity.zip_code" 
                                        v-on:keyup.13="searchCep"
                                        size="sm"
                                        placeholder="CEP" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6" sm="12">
                                    <b-form-group label="Endereço:" label-for="entity-adress">
                                        <b-form-input 
                                        id="entity-adress" 
                                        type="text"
                                        v-model="entity.adress" 
                                        size="sm"
                                        placeholder="Endereço..." 
                                    />
                                    </b-form-group>
                                </b-col>
                                <b-col md="2" sm="12">
                                    <b-form-group 
                                        label="Complemento:" 
                                        label-for="entity-complement">
                                        <b-form-input 
                                        id="entity-complement" 
                                        type="text"
                                        v-model="entity.complement" 
                                        size="sm"
                                        placeholder="Complemento..." />
                                    </b-form-group>
                                </b-col>
                                <b-col md="2" sm="12">
                                    <b-form-group 
                                        label="Número:" 
                                        label-for="entity-number">
                                        <b-form-input 
                                        id="entity-number" 
                                        type="text"
                                        v-model="entity.number" 
                                        size="sm"
                                        placeholder=" Número..." />
                                    </b-form-group>
                                </b-col>
                            </b-row>   
                            <b-row>
                                <b-col md="4" sm="12">
                                    <b-form-group 
                                        label="Bairro:" 
                                        label-for="entity-neighborhood">
                                        <b-form-input 
                                        id="entity-neighborhood" 
                                        type="text"
                                        v-model="entity.neighborhood" 
                                        size="sm"
                                        placeholder="Bairro" 
                                    />
                                    </b-form-group>
                                </b-col>
                                <b-col md="2" sm="12">
                                    <b-form-group 
                                        label="Estado:" 
                                        label-for="entity-state_id">
                                        <b-select 
                                        id="entity-state_id"
                                        size="sm"
                                        @input="loadCitys"
                                        :options="states" 
                                        v-model="entity.state_id" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Cidade:" 
                                        label-for="entity-city_id">
                                        <b-form-select id="entity-city_id"
                                        size="sm"
                                        :options="citys" v-model="entity.city_id" />
                                    </b-form-group>
                                    
                                </b-col>
                                
                            </b-row>
                        </b-form>    
                    </b-tab>
                    <b-tab title="Contato">
                        <b-form>
                            <b-row>
                                 <b-col md="5" sm="12">
                                    <b-form-group label="E-mail:" label-for="entity-email">
                                        <b-form-input id="entity-email" type="text"
                                        v-model="entity.email" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="E-mail" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group label="Telefone:" label-for="entity-telephone">
                                        <b-form-input id="entity-telephone" type="text"
                                        v-model="entity.telephone" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Telefone" />
                                    </b-form-group>
                                </b-col>
                                 <b-col md="3" sm="12">
                                    <b-form-group label="Celular:" label-for="entity-cellphone">
                                        <b-form-input id="entity-cellphone" type="text"
                                        v-model="entity.cellphone" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Telefone" />
                                    </b-form-group>
                                </b-col>   
                            </b-row>
                            <b-row>
                                <b-col md="6" sm="12">
                                    <b-form-group label="Imagem da Cliente/Fornecedor:" label-for="entity-photo">
                                        <b-form-file v-model="entity.photo" id="entity-photo" class="mt-3" accept=".jpg, .png, .gif" ></b-form-file>
                                    </b-form-group>
                                </b-col> 
                            </b-row>     
                        </b-form>
                        </b-tab>
                    </b-tabs>
                </b-card>
            <br>
         </b-form>
          <b-row>
                <b-col xs="12">
                    <b-button size="sm" variant="light" class="mr-2" 
                        @click="saveEntity"><i class="fa fa-plus"></i></b-button>
                </b-col>
            </b-row>
         
  </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import {mask} from 'vue-the-mask'

export default {
    name: 'EntityModal',
    directives: {mask},
    data: function() {
        return {
                mode: 'insert',
                entity: {},
                return_cep: {},
                state:{},
                city:{},
                entitys: [],
                states: [],
                citys: [],
                groupentitys: [],
            }
    },
     computed: {
        user(){
            return this.$store.state.user
        }
    },
    methods:{
        loadGroupEntity(){
                const url = `${baseApiUrl}/groupentitys`
                axios.get(url).then(res => {
                    this.groupentitys = res.data.map(groupentity => {
                        return { value: groupentity.id, text: !groupentity.synthetic ? ' => ' + groupentity.name : groupentity.name ,disabled: groupentity.synthetic ? true: false}
                    })
                })
        },
        loadStates() {
                const url = `${baseApiUrl}/states`
                axios.get(url).then(res => {
                    this.states = res.data.map(state => {
                        return { value: state.id, text: state.initials }
                    })
                })
        },
        loadCitys() {
                    let id = this.entity.state_id
                    if(id){
                        const url = `${baseApiUrl}/citys/${id}`
                        axios.get(url).then(res => {
                            this.citys = res.data.map(city => {
                                return { value: city.id, text: city.name }
                            })
                        })
                    }   
        },
        async saveEntity(){
                this.entity.type_entity_id = 1
                const method = this.entity.id ? 'put' : 'post'
                const id = this.entity.id ? `/${this.entity.id}` : ''
                await axios[method](`${baseApiUrl}/entitys${id}`, this.entity)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
        },
        searchCep() {
                if(this.entity.zip_code)
                {
                   let zip_code = this.entity.zip_code
                   delete axios.defaults.headers.common["Authorization"]
                    axios
                    .get(`https://viacep.com.br/ws/${ zip_code.replace('-','') }/json/`)
                    .then(res => {
                            this.return_cep = res.data
                            this.setZipCode()
                    })
                    .catch(showError)
                    
                } 
        },
        setZipCode(){

          this.entity.adress = this.return_cep.logradouro
          this.entity.neighborhood = this.return_cep.bairro
          this.setState()           
        },
        async setState(){

            const urlstate = `${baseApiUrl}/statesby/?initials=${this.return_cep.uf}`
            axios.defaults.headers.common['Authorization'] = `bearer ${this.user.token}`
            await axios(urlstate).then(
                    res=> {this.state = res.data
                            this.setCity() 
                    }  
            )
        },
        async setCity(){

          const urlcity = `${baseApiUrl}/citysby/${this.return_cep.ibge}`
          axios.defaults.headers.common['Authorization'] = `bearer ${this.user.token}`
          await axios(urlcity).then(res=> {
              this.city = res.data
               this.setCompl() 
          }
                                        
                                        )
         
        },
        setCompl(){
              this.entity.state_id = this.state[0].id
               this.entity.city_id = this.city[0].id
        },
        reset(){
            this.entity = {}
        }

    },
    mounted(){
            this.loadGroupEntity()
            this.loadStates()
         
    }
}
</script>

<style>
    .entity-modal select,label{
        font-size: 0.7rem;
    }
    .entity-modal input{
        font-size: 0.7rem;
    }
    .entity-modal button{
        font-size: 0.7rem;
    }
    .entity-modal h6{
        font-size: 0.7rem;

    }

</style>